import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-left no-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_popup_edit = _resolveComponent("q-popup-edit")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_toggle, {
        modelValue: _ctx.element.Positive,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.element.Positive) = $event)),
        "checked-icon": "add",
        color: "navy",
        label: "",
        size: "xs",
        "unchecked-icon": "remove"
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", {
        class: _normalizeClass(['q-my-none', 'q-pt-xs', 'cursor-pointer', { 'text-grey-8': !_ctx.element.Value }])
      }, [
        _createTextVNode(_toDisplayString(_ctx.getElementName) + " ", 1),
        _createVNode(_component_q_popup_edit, {
          modelValue: _ctx.element.Value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.element.Value) = $event)),
          "auto-save": "",
          fit: ""
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_q_input, {
              modelValue: _ctx.element.Value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.element.Value) = $event)),
              outlined: "",
              dense: "",
              autofocus: "",
              "no-error-icon": "",
              debounce: "500",
              onKeyup: _withKeys(scope.set, ["enter"])
            }, null, 8, ["modelValue", "onKeyup"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 2)
    ]),
    _createVNode(_component_q_btn, {
      class: "q-px-none q-mx-none q-mt-xs unset-items-center",
      flat: "",
      dense: "",
      "aria-label": _ctx.$t('delete_filter'),
      icon: "close",
      size: "sm",
      tabindex: "-1",
      color: "accent",
      onClick: _ctx.deleteItem
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tooltip, { delay: 1000 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('remove')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["aria-label", "onClick"])
  ], 64))
}